// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Do-z","breadcrumbForward":"Eo-z","breadcrumbBack":"Fo-z","selected":"Go-z"};